import { PaginatedResult } from '@nx-smartmonkey/shared/interfaces';

import { SearchPredicate } from '../../../domain/searchPredicates/SearchPredicate';
import { Stop } from '../../../domain/stop/Stop';
import { StopFlat } from '../../../domain/stop/StopFlat';
import { StopActionType, StopActions } from './actions';
import { StopsTableColumn, getStopsTableColumns, setStopsTableColumns } from './tableColumns';

const defaultPagination = {
  limit: 20,
  offset: 0,
  total: 0,
  docs: [],
} as PaginatedResult<Stop>;

export interface StopState {
  flat: Array<StopFlat>;
  pagination: PaginatedResult<Stop>;
  tableColumns: Array<StopsTableColumn>;
  selectedStops: Array<string>;
  predicates: Array<SearchPredicate>;
  predicatesBase64: string;
}

export const getInitialState = (): StopState => ({
  flat: [],
  pagination: defaultPagination,
  tableColumns: getStopsTableColumns(),
  selectedStops: [],
  predicates: [],
  predicatesBase64: ``,
});

export const StopReducer = (state: StopState, action: StopActions): StopState => {
  switch (action.type) {
    case StopActionType.SET_SEARCH_STOPS_PREDICATES: {
      const { predicates, predicatesBase64 } = action.payload;
      return {
        ...state,
        predicates,
        predicatesBase64,
      };
    }
    case StopActionType.SET_SELECTED_STOPS:
      return {
        ...state,
        selectedStops: action.payload.selectedStops,
      };
    case StopActionType.SET_STOPS_TABLE_COLUMNS:
      setStopsTableColumns(action.payload);
      return {
        ...state,
        tableColumns: action.payload,
      };
    case StopActionType.ON_SELECT_STOP: {
      const { stopId, withControlKey } = action.payload;
      let selectedStops = [stopId];

      if (withControlKey) {
        selectedStops = state.selectedStops.includes(stopId)
          ? state.selectedStops.filter((id) => id !== stopId)
          : [...state.selectedStops, stopId];
      }

      return {
        ...state,
        selectedStops,
      };
    }
    case StopActionType.SEARCH_STOPS_SUCCESS:
      return {
        ...state,
        pagination: action.payload.stopsPagination,
      };
    case StopActionType.SEARCH_FLAT_STOPS_SUCCESS:
      return {
        ...state,
        flat: action.payload.flatStops,
      };
    default:
      return state;
  }
};
